import * as url from 'url';
import * as semver from 'semver';
import * as api from './versions-api';
import * as repo from './versions-repository';
import * as installHelper from './install-helper';
import * as ui from './ui';
import {isIonicWebView} from '../../engine-dynamic/engine'

/**
 * Returns the url of the current location minus its hash and search queries.
 * @return {string}
 */
function getCurrentPathURL() {
    const url = new URL(window.location);
    url.hash = '';
    url.search = '';
    return url.href;
}

/**
 * Resolves inmediatelly if current running version if the latest available
 * locally. If it is not the promise resolution is held hostage and the window
 * is redirected to the path of the latest version locally available.
 *
 * @return {Promise.<void>}
 */
async function goToLatestLocalVersion() {
    const currentVersion = __VERSION__;
    const targetVersion = await repo.getLatestVersion();
    const targetVersionPath = await repo.getVersionInstallationPath(targetVersion);
    return new Promise((resolve) => {
        if (semver.eq(targetVersion, currentVersion)) {
            // If target version and current version are equal, resolve and
            // allow the invoker to continue.
            resolve();
        } else {
            // If target version is not the same as current running version
            // change the location to the targets version path, but DON'T
            // resolve, so the invoker stays waiting.
            console.debug(`Changing to local version ${targetVersion} at ${targetVersionPath}`);
            if(isIonicWebView()){
                window.location.replace(window.Ionic.WebView.convertFileSrc(targetVersionPath));
            }else{
                window.location.replace(targetVersionPath);
            }
        }
    });
}

export async function install() {
    // First update the index file pointer for the currently running version.
    await repo.setVersionInstallationPath(__VERSION__, getCurrentPathURL());
    // Check if we are running the correct version.
    // We will get redirected without promise resolution if there is a newer
    // version installed locally.
    await goToLatestLocalVersion();
    // Retrieve the latest version from the remote server and download it.
    // Go to it afterwards.
    const latestVersionSpec = await api.getLatestVersion();
    if (latestVersionSpec && semver.gt(latestVersionSpec.version, __VERSION__)) {
        console.warn(`New remote version available ${latestVersionSpec.version}, starting the update process...`);
        ui.show();
        await installHelper.installVersion(latestVersionSpec);
        await goToLatestLocalVersion();
    }
}



// WEBPACK FOOTER //
// ./src/shared/childupp-auto-update/cordova-auto-update/index.js